/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

export const TIME_PATTERN_FULL = 'HH:mm:ss';
export const TIME_PATTERN_SHORT = 'HH:mm';
export const DATE_PATTERN_FULL = 'DD-MM-YYYY-HH:mm:ss';

export const DATE_PATTERN_SLASH_PIPE = 'dd/MM/yyyy';
export const DATE_PATTERN_SLASH_MOMENT = 'dd/mm/yy';
export const DATE_PATTERN_SHORT_SLASH_MOMENT = 'dd/mm/yy';
export const DATE_PATTERN_SLASH = 'DD/MM/YYYY'
export const DATE_PATTERN_POINT = 'DD.MM.YYYY';
export const DATE_PATTERN_LINE = 'DD-MM-YYYY';
export const DATE_PATTERN_FULL_SLASH = 'DD/MM/YY HH:mm';
export const DATE_PATTERN_FULL_POINT = 'dd.MM.YYYY HH:mm';
export const DATE_PATTERN_FULL_LINE = 'DD-MM-YYYY HH:mm';

export const DATE_PATTERN_SHORT_MOMENT = DATE_PATTERN_SHORT_SLASH_MOMENT;
export const DATE_PATTERN_MOMENT = DATE_PATTERN_SLASH_MOMENT;
export const DATE_PATTERN_PIPE = DATE_PATTERN_SLASH_PIPE;
export const DATE_PATTERN_FULL_GLOBALLY = DATE_PATTERN_FULL_SLASH;

export const DATE_PATTERN_FULL_DAY_AND_TIME = 'EEEE,d MMMM HH:mm';

export const MEDIUM_PASSWORD_PATTERN = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.{9,})'
export const STRONG_PASSWORD_PATTERN = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.{12,})'
export const MINIMUM_PASSWORD_LENGTH = 9
export const MAXIMUM_PASSWORD_LENGTH = 32
export const MINIMUM_DEFAULT_STRING_INPUT_LENGTH = 1
export const MAXIMUM_DEFAULT_STRING_INPUT_LENGTH = 255
export const DEFAULT_START_TIME = '00:00'
export const DEFAULT_END_TIME = '23:30'
export const DEFAULT_TIMEZONE = 'Europe/Bucharest'

export const consts = {
  DATE_PATTERN_FULL_GLOBALLY,
  DATE_PATTERN_PIPE,
  DATE_PATTERN_MOMENT,
  DATE_PATTERN_SHORT_MOMENT,
  DATE_PATTERN_FULL_LINE,
  DATE_PATTERN_FULL_POINT,
  DATE_PATTERN_FULL_SLASH,
  DATE_PATTERN_LINE,
  DATE_PATTERN_SLASH,
  DATE_PATTERN_SHORT_SLASH_MOMENT,
  DATE_PATTERN_SLASH_MOMENT,
  DATE_PATTERN_SLASH_PIPE,
  DATE_PATTERN_FULL,
  TIME_PATTERN_SHORT,
  TIME_PATTERN_FULL,
  DATE_PATTERN_FULL_DAY_AND_TIME,
  DEFAULT_TABLE_ROWS: 12,
  MEDIUM_PASSWORD_PATTERN,
  STRONG_PASSWORD_PATTERN,
  MINIMUM_PASSWORD_LENGTH,
  MAXIMUM_PASSWORD_LENGTH,
  DEFAULT_START_TIME,
  DEFAULT_END_TIME,
  DEFAULT_TIMEZONE
}
